module.exports = __webpack_public_path__ + "static/img/诗仙会客厅3.335ea5dd.png";